import React, { Fragment } from "react";

import ModalBody from "../../../../../app/_components/ModalBody";
import ModalHeader from "../../../../../app/_components/ModalHeader";
import KitLinkSettings from "./KitLinkSettings";
import { useGetKits } from "@selectors/getters";

type Props = {
  kitId: string;
};

const ShareKitModal: React.FC<Props> = ({ kitId }) => {
  const kit = useGetKits()[kitId];
  return (
    <Fragment>
      <ModalHeader title={`Share ${kit.name}`} />
      <ModalBody>
        <KitLinkSettings kit={kit} />
      </ModalBody>
    </Fragment>
  );
};

export default ShareKitModal;
